export const PromoCodeCheck = /* GraphQL */ `
  query PromoCodeCheck($code: String!, $productId: String!) {
    PromoCodeCheck(code: $code, productId: $productId) {
      success
      data
    }
  }
`;
